import React from 'react';
import OldBotSettingsSection from '../../../../configure/panels/sections/BotSettingsSection/BotSettingsSection';

export const Chatbot = () => {
  return <OldBotSettingsSection />;
};
